<template>
  <div class="admin-wrapper">
    <br />
    <el-tabs v-model="activeName" @tab-click="handleTabClick">
      <el-tab-pane label="Share Designs" name="first">
        <el-row :gutter="10">
          <el-col :xs="24" :sm="24" :md="12">
            <!-- staged themes card -->
            <el-card class="box-card">
              <div slot="header" class="clearfix">
                <span>Staged Designs</span>
                <br />
                <sup>Designs may take a moment to populate</sup>
              </div>
              <div slot="header" class="clearfix" v-loading="isLoading">
                <el-form ref="form" :model="form">
                  <el-form-item>
                    <el-input
                      v-model="form.email"
                      style="float: left; width: 480px;"
                      placeholder="Who do you want to share designs with?"
                    ></el-input>
                    <el-button
                      style="float: left; padding: 11px 10px 12px 10px; margin: 0 5px 0 5px"
                      type="primary"
                      @click="shareThemes"
                      >Share</el-button
                    >
                  </el-form-item>
                </el-form>
                <div v-if="isLoading" class="fade">
                  Loading
                </div>
              </div>
              <div>
                <el-table :v-bind="themes" :data="themes" align="left" style="width: 100%">
                  <el-table-column label="Preview Image" width="200">
                    <template slot-scope="scope">
                      <img :src="designImageSRCLink + scope.row.backgroundImage" :width="150" />
                    </template>
                  </el-table-column>
                  <el-table-column label="Design ID">
                    <template slot-scope="scope">
                      {{ scope.row._id }}
                    </template></el-table-column
                  >
                  <el-table-column label="Name" width="200">
                    <template slot-scope="scope">
                      {{ scope.row.name }}
                    </template>
                  </el-table-column>
                  <el-table-column label="Delete">
                    <template slot-scope="scope">
                      <el-button
                        type="danger"
                        icon="el-icon-delete"
                        @click="deleteStagedTheme(scope.row._id)"
                        >Remove</el-button
                      >
                    </template></el-table-column
                  >
                </el-table>
              </div>
            </el-card>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12">
            <!-- user email to share themese with card -->
            <el-card class="box-card">
              <div slot="header" class="clearfix">
                <span>Find themes to share via email...</span>
                <el-form ref="form" :model="form" v-loading="isLoading">
                  <el-form-item>
                    <el-input
                      v-model="search.email"
                      placeholder="Email address"
                      style="float: left; width: 480px;"
                    ></el-input>
                    <el-button
                      style="float: left; padding: 11px 10px 12px 10px; margin: 0 5px 0 5px"
                      type="primary"
                      @click="locateThemes"
                      >Search</el-button
                    >
                  </el-form-item>
                </el-form>
              </div>
              <div>
                <el-table :data="searchedThemes" style="width: 100%" align="center">
                  <el-table-column label="Image" width="150">
                    <template slot-scope="scope">
                      <img :src="designImageSRCLink + scope.row.backgroundImage" :width="150" />
                    </template>
                  </el-table-column>
                  <el-table-column label="Name" width="150">
                    <template slot-scope="scope">
                      {{ scope.row.name }}
                    </template>
                  </el-table-column>
                  <el-table-column label="Deleted" width="100">
                    <template slot-scope="scope">
                      <span v-if="scope.row.deleted">Deleted</span>
                      <span v-if="!scope.row.deleted">Not Deleted</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="Staged" width="100">
                    <template slot-scope="scope">
                      <div v-if="scope.row.isStaged" style="color:green;">
                        <span> Staged</span>
                      </div>
                      <div v-else>
                        <span>Not Staged</span>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column label="Operation" width="100">
                    <template slot-scope="scope">
                      <el-button @click="stageToShareTheme(scope.row)">Stage</el-button>
                    </template>
                  </el-table-column> </el-table
                ><br />
              </div>
            </el-card>
          </el-col>
        </el-row>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import axios from "axios";
import ThemeService from "@/api/theme.service";
import MailService from "@/api/mail.service";

export default {
  name: "conference",
  data() {
    return {
      form: { email: "" },
      search: { email: "" },
      themes: [],
      searchedThemes: [],
      activeName: "first",
      apiURL: `${this.$store.state.apiEndpoint}/api/`,
      designImageSRCLink: "https://s3-us-west-2.amazonaws.com/wavvegram/background/",
      isLoading: false
    };
  },
  computed: {},
  created() {
    this.getStagedThemes();
  },
  methods: {
    stageToShareTheme(row) {
      console.log("row-----------");
      console.log(row._id);
      const data = {
        id: row._id
      };
      ThemeService.stageToShareTheme(data).then(response => {
        this.$message({
          type: "info",
          message: response
        });
        this.getStagedThemes();
      });
    },
    async locateThemes() {
      const data = { user: this.search.email, isSearchingForStagedThemes: true };
      const jobsURL = this.apiURL.concat(`themes/searchForUserThemes`);
      const searchedDesigns = await axios.post(jobsURL, data);
      this.searchedThemes = searchedDesigns;
    },
    async getStagedThemes() {
      this.isLoading = true;
      const url = this.apiURL.concat("themes/getStagedThemes");
      await axios.get(url).then(response => {
        this.themes = response;
        this.isLoading = false;
      });
    },
    async deleteStagedTheme(themeID) {
      const data = { id: themeID };
      const url = this.apiURL.concat("themes/removeStageToShareTheme");
      const response = await axios.post(url, data);
      this.$notify({
        title: "Response From Server",
        message: ("i", { style: "color: teal" }, response)
      });
      this.getStagedThemes();
    },
    async shareThemes() {
      let regex = new RegExp("[a-z0-9]+@[a-z]+\.[a-z]{2,3}");
      if (regex.test(this.form.email)) {
        let response = await Promise.all(
          this.themes.map(async theme => await this.cloneTheme(theme))
        );
        console.log("response: ", response);
        const data = {
          email: this.form.email
        };
        if (
          response[0] !==
          "User does not have an account. Have the user create an account in Wavve before sharing a theme with them."
        ) {
          MailService.sendThemeSharedEmail(data);
        } else {
          console.log("User does not have an account to share themes with.");
        }
      } else {
        this.$notify({
          title: "Email Invalid",
          message: ("i", { style: "color: teal" }, "Check Email Address")
        });
      }
    },
    cloneTheme(themeID) {
      return new Promise(async resolve => {
        const data = {
          id: themeID,
          user: this.form.email
        };
        ThemeService.clone(data).then(response => {
          this.$message({
            type: "Status",
            message: response
          });
          resolve(response);
        });
      });
    },
    handleTabClick(tab, event) {
      this.activeName = tab;
      console.log(tab, event);
    }
  }
};
</script>
<style scoped>
.fade {
  animation: fadeIn 0.5s;
}
.admin-wrapper {
  margin: 0 10px 0 10px;
}
</style>
